import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  zh: {
    translation: {
      nearby: "附近",
      messages: "消息",
      likes: "喜欢",
      peopleNav: "附近的人",
      unreadOnly: "只看未读",
      showAllMessages: "显示全部消息",
      noUnreadMessages: "目前没有未读消息",
      viewAllMatches: "查看全部附近会员",
      unreadCount: "{{count}} 条未读消息",
      peopleNearby: "附近的人",
      peopleSubtitle: "随机距离 · 下拉查看更多",
      loadMore: "加载更多",
      loadingMore: "正在加载附近的人…",
      allPeopleLoaded: "附近的人已经全部加载",
      openPhoto: "查看{{name}}的大图",
      closePhoto: "关闭大图",
      viewProfile: "查看资料",
      messageHer: "发消息",
      openFullPhoto: "查看完整大图",
      profile: "我的",
      details: "详情",
      match: "匹配成功",
      chat: "聊天",
      skip: "跳过",
      like: "喜欢",
      sayHi: "打个招呼",
      keepBrowsing: "继续看看",
      photos: "相册",
      videos: "视频",
      contact: "联系方式",
      lockedPhotos: "普通会员可看前3张",
      vipUnlock: "开通VIP解锁",
      matchUnlock: "VIP会员可见",
      distance: "距你 {{value}}",
      online: "在线",
      newMatches: "新匹配",
      emptyMessages: "还没有消息，去附近认识新朋友吧",
      emptyLikes: "你喜欢的人会出现在这里",
      editProfile: "编辑资料",
      formalAccount: "正式会员",
      temporaryAccount: "临时会员",
      register: "注册正式会员",
      save: "保存",
      name: "名称",
      email: "邮箱",
      password: "密码",
      interests: "兴趣爱好",
      logout: "退出登录",
      send: "发送",
      messagePlaceholder: "输入消息…",
      freeLimit: "普通会员每位女性最多发送3条消息",
      vipRequired: "已达到3条免费消息上限，开通VIP后继续聊天",
      videoLocked: "视频仅VIP可看",
      photoLocked: "更多照片仅VIP可看",
      contactLocked: "VIP会员可见",
      voiceLocked: "开通VIP后可使用语音功能",
      vipPromptTitle: "VIP 专属功能",
      report: "举报",
      back: "返回",
      verified: "已认证",
      noMore: "附近暂时没有更多资料",
      refresh: "重新查看",
      refreshingNearby: "正在重新匹配附近的人…",
      accountSaved: "资料已保存",
      registered: "已升级为正式会员",
      admin: "管理后台",
      messageNotifications: "消息通知",
      notificationsDescription: "有新招呼或聊天消息时及时提醒你。",
      notificationsDenied: "通知权限已关闭，请在系统设置中开启。",
      notificationsActive: "已开启，后台和锁屏时也能收到消息提醒。",
      notificationsServerPending: "本地后台提醒已开启；Firebase 可在后续正式版本接入。",
      enableNotifications: "开启",
      refreshNotifications: "刷新",
      enablingNotifications: "开启中…",
      swipeHint: "左滑跳过，右滑喜欢",
      matchPair: "你和{{name}}互相喜欢了！",
      matchIntro: "快去打个招呼，开启美好对话吧",
      startConversation: "开始聊聊吧",
      nearbyLoadFailed: "附近的人加载失败",
      tryAgain: "重新加载",
      safetyNote: "请文明聊天，注意保护个人隐私和财产安全。",
      vipActiveCopy: "相册、视频、联系方式和消息已解锁",
      vipInactiveCopy: "由管理员开通，解锁完整体验",
      accountRegisterCopy: "保存当前资料和全部会话，可在其他时间重新登录。",
    },
  },
  vn: {
    translation: {
      nearby: "Gần đây",
      messages: "Tin nhắn",
      likes: "Yêu thích",
      peopleNav: "Mọi người",
      unreadOnly: "Chỉ chưa đọc",
      showAllMessages: "Hiện tất cả tin nhắn",
      noUnreadMessages: "Bạn đã đọc hết tin nhắn",
      viewAllMatches: "Xem tất cả người ở gần",
      unreadCount: "{{count}} tin nhắn chưa đọc",
      peopleNearby: "Người ở gần bạn",
      peopleSubtitle: "Khoảng cách ngẫu nhiên · Kéo để xem thêm",
      loadMore: "Xem thêm",
      loadingMore: "Đang tìm thêm người gần bạn…",
      allPeopleLoaded: "Bạn đã xem tất cả người ở gần",
      openPhoto: "Mở ảnh của {{name}}",
      closePhoto: "Đóng ảnh",
      viewProfile: "Xem hồ sơ",
      messageHer: "Nhắn tin",
      openFullPhoto: "Xem ảnh đầy đủ",
      profile: "Hồ sơ",
      details: "Hồ sơ",
      match: "Hai bạn đã kết đôi!",
      chat: "Trò chuyện",
      skip: "Bỏ qua",
      like: "Thích",
      sayHi: "Chào cô ấy",
      keepBrowsing: "Xem thêm",
      photos: "Ảnh",
      videos: "Video",
      contact: "Liên hệ",
      lockedPhotos: "Thành viên thường được xem 3 ảnh đầu",
      vipUnlock: "Mở khóa VIP",
      matchUnlock: "Chỉ dành cho thành viên VIP",
      distance: "Cách bạn {{value}}",
      online: "Đang trực tuyến",
      newMatches: "Kết nối mới",
      emptyMessages: "Chưa có tin nhắn. Hãy gặp người ở gần bạn.",
      emptyLikes: "Người bạn thích sẽ xuất hiện ở đây",
      editProfile: "Sửa hồ sơ",
      formalAccount: "Thành viên đã đăng ký",
      temporaryAccount: "Tài khoản tạm thời",
      register: "Tạo tài khoản chính thức",
      save: "Lưu",
      name: "Tên",
      email: "Email",
      password: "Mật khẩu",
      interests: "Sở thích",
      logout: "Đăng xuất",
      send: "Gửi",
      messagePlaceholder: "Nhập tin nhắn…",
      freeLimit: "Thành viên thường được gửi 3 tin nhắn cho mỗi người",
      vipRequired: "Hãy mở VIP để tiếp tục sử dụng tính năng này.",
      videoLocked: "Mở VIP để xem video này",
      photoLocked: "Mở VIP để xem thêm ảnh",
      contactLocked: "Mở VIP để xem thông tin liên hệ",
      voiceLocked: "Mở VIP để gửi tin nhắn thoại",
      vipPromptTitle: "Dành cho thành viên VIP",
      report: "Báo cáo",
      back: "Quay lại",
      verified: "Đã xác minh",
      noMore: "Hiện không còn hồ sơ nào ở gần",
      refresh: "Xem lại",
      refreshingNearby: "Đang tìm người mới ở gần bạn…",
      accountSaved: "Đã lưu hồ sơ",
      registered: "Đã tạo tài khoản chính thức",
      admin: "Quản trị",
      messageNotifications: "Thông báo tin nhắn",
      notificationsDescription: "Nhận thông báo khi có lời chào hoặc tin nhắn mới.",
      notificationsDenied: "Thông báo đang tắt. Hãy bật trong cài đặt Android.",
      notificationsActive: "Đã bật thông báo nền và màn hình khóa.",
      notificationsServerPending: "Thông báo cục bộ đã bật; Firebase sẽ được kết nối sau.",
      enableNotifications: "Bật",
      refreshNotifications: "Làm mới",
      enablingNotifications: "Đang bật…",
      swipeHint: "Vuốt trái để bỏ qua, vuốt phải để thích",
      matchPair: "Bạn và {{name}} đã thích nhau!",
      matchIntro: "Hãy gửi lời chào và bắt đầu trò chuyện.",
      startConversation: "Bắt đầu trò chuyện",
      nearbyLoadFailed: "Không thể tải người ở gần",
      tryAgain: "Thử lại",
      safetyNote: "Hãy trò chuyện lịch sự và bảo vệ quyền riêng tư, tài sản của bạn.",
      vipActiveCopy: "Ảnh, video, liên hệ và trò chuyện đã được mở khóa",
      vipInactiveCopy: "VIP do quản trị viên kích hoạt để mở toàn bộ trải nghiệm",
      accountRegisterCopy: "Lưu hồ sơ và cuộc trò chuyện để đăng nhập lại sau.",
    },
  },
  en: {
    translation: {
      nearby: "Nearby",
      messages: "Messages",
      likes: "Likes",
      peopleNav: "People",
      unreadOnly: "Unread only",
      showAllMessages: "Show all messages",
      noUnreadMessages: "You're all caught up",
      viewAllMatches: "View all nearby people",
      unreadCount: "{{count}} unread messages",
      peopleNearby: "People Nearby",
      peopleSubtitle: "Random distances · Scroll for more",
      loadMore: "Load more",
      loadingMore: "Finding more people nearby…",
      allPeopleLoaded: "You've seen everyone nearby",
      openPhoto: "Open {{name}}'s photo",
      closePhoto: "Close photo",
      viewProfile: "View profile",
      messageHer: "Message",
      openFullPhoto: "View full photo",
      profile: "Profile",
      details: "Profile",
      match: "It's a Match!",
      chat: "Chat",
      skip: "Skip",
      like: "Like",
      sayHi: "Say Hi",
      keepBrowsing: "Keep Browsing",
      photos: "Photos",
      videos: "Videos",
      contact: "Contact",
      lockedPhotos: "Free members can view the first 3 photos",
      vipUnlock: "Unlock with VIP",
      matchUnlock: "Visible to VIP members",
      distance: "{{value}} away",
      online: "Online",
      newMatches: "New Matches",
      emptyMessages: "No messages yet. Meet someone nearby.",
      emptyLikes: "People you like will appear here",
      editProfile: "Edit Profile",
      formalAccount: "Registered member",
      temporaryAccount: "Temporary member",
      register: "Create permanent account",
      save: "Save",
      name: "Name",
      email: "Email",
      password: "Password",
      interests: "Interests",
      logout: "Log out",
      send: "Send",
      messagePlaceholder: "Type a message…",
      freeLimit: "Free members can send 3 messages to each person",
      vipRequired: "You've used 3 free messages. Upgrade to VIP to keep chatting.",
      videoLocked: "Videos are available to VIP members",
      photoLocked: "More photos are available to VIP members",
      contactLocked: "Visible to VIP members",
      voiceLocked: "Upgrade to VIP to send voice messages",
      vipPromptTitle: "VIP feature",
      report: "Report",
      back: "Back",
      verified: "Verified",
      noMore: "No more nearby profiles right now",
      refresh: "Start over",
      refreshingNearby: "Shuffling more people nearby…",
      accountSaved: "Profile saved",
      registered: "Permanent account created",
      admin: "Admin",
      messageNotifications: "Message notifications",
      notificationsDescription: "Get notified when a new greeting or message arrives.",
      notificationsDenied: "Notifications are off. Enable them in Android settings.",
      notificationsActive: "Enabled for background and lock-screen messages.",
      notificationsServerPending: "Local background alerts are on. Firebase can be connected in a later release.",
      enableNotifications: "Enable",
      refreshNotifications: "Refresh",
      enablingNotifications: "Enabling…",
      swipeHint: "Swipe left to skip, right to like",
      matchPair: "You and {{name}} liked each other!",
      matchIntro: "Start a conversation and get to know each other better.",
      startConversation: "Start a conversation",
      nearbyLoadFailed: "Could not load people nearby",
      tryAgain: "Try again",
      safetyNote: "Be kind and respectful. Protect your privacy and safety.",
      vipActiveCopy: "Photos, videos, contacts and chat are unlocked",
      vipInactiveCopy: "Admin-enabled access to the full experience",
      accountRegisterCopy: "Keep your profile and conversations, and sign in again later.",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
